const HATCH_ID = 'bad-crane-hatch';
// Mast + drooping jib as one continuous stroke — same "thick outline, hatch-fill
// pass, then white front pass" technique as QuestionMarkDoodle, just bent into a
// crane silhouette that sags rather than standing crisp.
const BOOM_PATH =
  'M50 232 C47 176 51 108 58 62 C60 46 76 34 118 30 C144 28 165 34 179 47';

const GROUND_HATCH = Array.from({ length: 8 }, (_, i) => {
  const x = 24 + i * 16;
  return { x1: x, y1: 240, x2: x + 16, y2: 226 };
});

export function BadCraneDoodle() {
  return (
    <svg
      className="ap-coming-soon__doodle"
      viewBox="0 0 220 260"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id={HATCH_ID}
          width="7"
          height="7"
          patternTransform="rotate(45)"
          patternUnits="userSpaceOnUse"
        >
          <rect width="7" height="7" fill="#fff" />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="7"
            stroke="#1d1d1f"
            strokeWidth="1.6"
          />
        </pattern>
      </defs>

      {/* shadow layer, offset like the FAQ mark */}
      <path
        d={BOOM_PATH}
        transform="translate(7 7)"
        stroke="#1d1d1f"
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={BOOM_PATH}
        transform="translate(7 7)"
        stroke={`url(#${HATCH_ID})`}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* front layer */}
      <path
        d={BOOM_PATH}
        stroke="#1d1d1f"
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={BOOM_PATH}
        stroke="#fff"
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* counterweight, tacked crookedly onto the back of the jib */}
      <polygon
        points="92,33 116,31 114,48 90,49"
        transform="rotate(-6 103 40)"
        fill={`url(#${HATCH_ID})`}
        stroke="#1d1d1f"
        strokeWidth="3"
      />

      {/* cable, sagging off-center instead of hanging straight */}
      <path
        d="M179 47 C184 82 152 92 158 128"
        stroke="#1d1d1f"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* hook, curled the wrong way */}
      <path
        d="M158 128 C158 137 168 139 167 130"
        stroke="#1d1d1f"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      {/* the load — a crate slipping mid-swing */}
      <g transform="rotate(-24 118 168)">
        <polygon
          points="92,150 144,150 144,188 92,188"
          fill={`url(#${HATCH_ID})`}
          stroke="#1d1d1f"
          strokeWidth="3.5"
        />
        <line
          x1="92"
          y1="169"
          x2="144"
          y2="169"
          stroke="#1d1d1f"
          strokeWidth="2"
        />
      </g>

      {/* a couple of "uh-oh" wobble marks off the swinging load */}
      <g stroke="#1d1d1f" strokeWidth="2" strokeLinecap="round">
        <path d="M162 108 C168 104 168 112 174 108" />
        <path d="M170 118 C175 115 175 121 180 118" />
      </g>

      <g stroke="#1d1d1f" strokeWidth="2.5" strokeLinecap="round">
        {GROUND_HATCH.map((l, i) => (
          <line key={i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2} />
        ))}
      </g>
    </svg>
  );
}
